<div class="expansion-panel" [class.-expanded]="expanded">
  <div class="expansion-panel-header">
    <span class="fa -toggle" [ngClass]="{ 'fa-chevron-right': !expanded, 'fa-chevron-down': expanded }" (click)="toggle()"></span>
    <div class="expansion-panel-header-content">
      <ng-content select="[expansion-header]"></ng-content>
    </div>
  </div>
  <div class="expansion-panel-content">
    <ng-content select="[expansion-content]"></ng-content>
  </div>
</div>
